import React from "react";
import classes from "./Tnc.module.css";
import { useNavigate } from "react-router-dom";

const Tnc = () => {
  const navigate = useNavigate();

  return (
    <div className={classes.main_container}>
    <div className={classes.container}>
    <p className={classes.title}>Terms & Conditions</p>
    <br />
    <p className={classes.desc}>H2N Games is a gaming and entertainment portal. This portal covers a wide range of mental skills. This portal has plenty of popular games like racing, skills, adventure, and sports that will give users the sparks their skills and creativity.</p>
    <ul>
    <li className="list-disc">The service cost is KSH 15/day.</li>
    <li className="list-disc">Your Subscription will be renewed at KSH 15/day, automatically until you unsubscribe.</li>
    <li className="list-disc">You can unsubscribe from H2N Games, anytime.</li>
    <li className="list-disc">You must be more than 14+ to have received permission from your parents or guardian who is authorized to pay your bill.</li>
    <li className="list-disc">All data-enabled features and smartphone users can enjoy full service.</li>
    <li className="list-disc">Customer can access the content at any time during the subscription validity period.</li>
    </ul>
    </div>
    </div>
  );
};

export default Tnc;
